import { render, staticRenderFns } from "./BuyBack.vue?vue&type=template&id=4c68508c&scoped=true"
import script from "./BuyBack.vue?vue&type=script&lang=js"
export * from "./BuyBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c68508c",
  null
  
)

/* custom blocks */
import block0 from "./BuyBack.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports